import React from 'react';
import { useCityNameById } from '../../../hooks/useCity';
import { useCountryNameById } from '../../../hooks/useCountry';
import { useTeamNameById } from '../../../hooks/useTeam';
import { useDivisionNameById } from '../../../hooks/useDivision';
import { useRelationshipNameById } from '../../../hooks/useRelationship';
import { useSpendTypeNameById } from '../../../hooks/useSpendType';
import { useEventTypeNameById } from '../../../hooks/useEventType';
import { useActivityTypeNameById } from '../../../hooks/useActivityType';
import { useExternalSourceNameById } from '../../../hooks/useExternalSource';
import { formatTime } from '../../../utils/helpers';
import { useOrganizationNameById } from '../../../hooks/useOrganization';
import { useBrandNameById } from '../../../hooks/useBrand';
export const StepFour = ({ formData }) => {
  const { data: cityName } = useCityNameById(formData.city_id);
  const { data: countryName } = useCountryNameById(formData.country_id);
  const { data: teamName } = useTeamNameById(formData.team_id);
  const { data: brandName } = useBrandNameById(formData.brand_id);
  const { data: divisionName } = useDivisionNameById(formData.division_id);
  const { data: relationshipData } = useRelationshipNameById(formData.relationship_id);
  const { data: spendTypeData } = useSpendTypeNameById(formData.spend_type_id);
  const { data: eventTypeData } = useEventTypeNameById(formData.event_type_id);
  const { data: activityTypeData } = useActivityTypeNameById(formData.activity_type_id);
  const { data: externalSourceData } = useExternalSourceNameById(formData.external_source_id);
  const { data: organizationName } = useOrganizationNameById(formData.organization_id);

  return (
    <div className="container mx-auto ">
      <div className=" p-5 mb-4 ">
        <div className='mb-6'>
          <p className="text-white text-2xl bg-blueColor p-2 rounded w-fit font-bold">
            Event ID : <span className="font-bol">{formData.event_id}</span> </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pb-6 border-b border-slate-200">
          <div>
            <p className="text-gray-600">Event/Topic Name:</p>
            <p className="font-semibold">{formData.name}</p>
          </div>
          <div>
            <p className="text-gray-600">Event Type:</p>
            <p className="font-semibold">{eventTypeData}</p>
          </div>
          <div>
            <p className="text-gray-600">Activity Type:</p>
            <p className="font-semibold">{activityTypeData}</p>
          </div>
          <div>
            <p className="text-gray-600">Spend Type:</p>
            <p className="font-semibold">{spendTypeData}</p>
          </div>

          <div>
            <p className="text-gray-600">Event Date (Start):</p>
            <p className="font-semibold">{formData.start_date} at {formatTime(formData.start_time)}</p>
          </div>
          <div>
            <p className="text-gray-600">Event Date (End):</p>
            <p className="font-semibold">{formData.end_date} at {formatTime(formData.end_time)}</p>
          </div>
          <div>
            <p className="text-gray-600">Country of Event:</p>
            <button className="bg-blueColor text-white rounded px-2 py-1 text-sm cursor-default">
              {countryName}
            </button>
          </div>
          <div>
            <p className="text-gray-600">Event City:</p>
            <button className="bg-blueColor text-white rounded px-2 py-1 text-sm cursor-default">
              {cityName}
            </button>
          </div>
          <div>
            <p className="text-gray-600">Created By</p>
            <p className="font-semibold">{formData.created_by_name}</p>
          </div>
          <div>
            <p className="text-gray-600">Currency:</p>
            <button className="bg-blueColor text-white rounded px-2 py-1 text-sm cursor-default">
              {formData.currency}
            </button>
          </div>
        </div>
        <div className='flex items-center gap-8 pt-4 pb-6 border-b border-slate-200'>
          <div className="">
            <p className="my-2 text-gray-600 font-thin">
              <b>Font Color:</b>
            </p>
            <div
              className="border"
              style={{
                width: "50px",
                height: "20px",
                borderRadius: "5px",
                backgroundColor: formData.font_color,
              }}
            ></div>
          </div>

          <div className="">
            <p className="my-2 text-gray-600 font-thin">
              <b>Background Color:</b>
            </p>
            <div
              className="border"
              style={{
                width: "50px",
                height: "20px",
                borderRadius: "5px",
                backgroundColor: formData.bg_color,
              }}
            ></div>
          </div>

          <div className="">
            <p className="my-2 text-gray-600 font-thin">
              <b>Button Color:</b>
            </p>
            <div
              className="border"
              style={{
                width: "50px",
                height: "20px",
                borderRadius: "5px",
                backgroundColor: formData.btn_color,
              }}
            ></div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pb-6 pt-5">
          {
            organizationName && (
              <div>
                <p className="text-gray-600">Organization:</p>
                <p className="font-semibold">{organizationName}</p>
              </div>
            )
          }
          <div>
            <p className="text-gray-600">Promo/GPAS Approval Date:</p>
            <p className="font-semibold">{formData.promo_approval_date}</p>
          </div>
          <div>
            <p className="text-gray-600">Division:</p>
            <p className="font-semibold">{divisionName}</p>
          </div>
          <div>
            <p className="text-gray-600">Team:</p>
            <p className="font-semibold">{teamName}</p>
          </div>
          <div>
            <p className="text-gray-600">Brand:</p>
            <p className="font-semibold">{brandName}</p>
          </div>
          <div>
            <p className="text-gray-600">Promo/GPAS Number/UPI:</p>
            <p className="font-semibold">{formData.promo_number}</p>
          </div>
          <div>
            <p className="text-gray-600">External Source System/Process:</p>
            <p className="font-semibold">{externalSourceData}</p>
          </div>
          <div>
            <p className="text-gray-600">Relationship of this recipient:</p>
            <p className="font-semibold">{relationshipData}</p>
          </div>
        </div>
      </div>
    </div>
  );
};